import createApi from "../utils/axiosInstance";

export const getRecentMealsFromPast = async (
  currentDate,
  userId,
  type,
  searchTerm,
  limit,
  page,
  favoritePage,
  favoriteLimit
) => {
  try {
    const api = createApi(true);

    const response = await api.get(
      `/user/get-recent-meal?date=${currentDate}&type=${type}&search=${searchTerm}&page=${page}&limit=${limit}&favoritePage=${favoritePage}&favoriteLimit=${favoriteLimit}&${
        userId ? `&userId=${userId}` : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get recent meal failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getUserFavroiteMealData = async (
  currentDate,
  userId,
  limit,
  page
) => {
  try {
    const api = createApi(true);

    const response = await api.get(
      `/user/get-user-favorite-meals?date=${currentDate}&page=${page}&limit=${limit}&${
        userId ? `&userId=${userId}` : ""
      }`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get favorite user meal failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
